/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : ViewVariant.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MultipleVariants from "./MultipleVariants";
import AddButtonV2 from "../common/button/AddButtonV2";
import { useDispatch, useSelector } from "react-redux";
import RefreshIcon from "@mui/icons-material/Refresh";

function ViewVariant({
  expanded,
  setExpanded,
  variantDetailsSelected,
  expandedIndex,
  setExpandedIndex,
  handleVariantToggle,
  handleAddVariant,
  logs,
  loading,
  setExpandVCLogs,
  expandVCLogs,
  vehicleStatusData,
  logsCount,
  handleEditClick,
  rowsPerPageVCLogCount,
  pageVCLogCount,
  handlePageChangeLogsVC,
  isRecreatedProject,
  onRecreateVariantClick,
}) {
  const { variantInfo } = useSelector((state) => state.variantReducer);
  const handleAccordionToggle = () => {
    setExpanded(!expanded);
  };
  const dispatch = useDispatch();

  return (
    <Box sx={{ width: "100%" }}>
      <Accordion
        expanded={expanded}
        sx={{
          boxShadow: 3,
          borderRadius: 0,
          backgroundColor: "#f9f9f9",
          "&:before": { display: "none" },
          p: 0,
          "& .MuiAccordionDetails-root": {
            p: 0,
          },
        }}
        onChange={handleAccordionToggle}
      >
        <AccordionSummary
          expandIcon={
            expanded ? (
              <ExpandMoreIcon sx={{ color: "white" }} />
            ) : (
              <ExpandMoreIcon sx={{ color: "white" }} />
            )
          }
          sx={{
            backgroundColor: "black",
            color: "white",
            minHeight: "48px !important",
            "& .MuiAccordionSummary-content": {
              // margin: "8px 0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
              p: 0,
            },
          }}
        >
          <Typography
            variant="body2"
            sx={{ fontWeight: 600, fontFamily: "Manrope, sans-serif" }}
          >
            Variant Configuration
          </Typography>
          <Box sx={{ display: "flex", gap: 1 }}>
            {isRecreatedProject && (
              <Box
                sx={{ mb: -1, cursor: "pointer" }}
                onClick={onRecreateVariantClick}
              >
                <RefreshIcon />
              </Box>
            )}
            <AddButtonV2 handleOnClick={handleAddVariant} />
          </Box>
        </AccordionSummary>

        <AccordionDetails
          sx={{
            backgroundColor: "white",
            maxHeight: 600,

          }}
        >
          {variantDetailsSelected?.length > 0 ? (
            variantDetailsSelected?.map((variant, index) => (
              <MultipleVariants
                handlePageChangeLogsVC={handlePageChangeLogsVC}
                logsCount={logsCount}
                handleEditClick={handleEditClick}
                setExpandVCLogs={setExpandVCLogs}
                expandVCLogs={expandVCLogs}
                loading={loading}
                logs={logs}
                key={index}
                variant={variant}
                expanded={expandedIndex === index}
                onToggle={() => handleVariantToggle(index, variant)}
                vehicleStatusData={vehicleStatusData}
                pageVCLogCount={pageVCLogCount}
                rowsPerPageVCLogCount={rowsPerPageVCLogCount}
              />
            ))
          ) : (
            <Typography>No Variants Found</Typography>
          )}
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

export default ViewVariant;
